module.exports = __webpack_public_path__ + "ca2a59cb/img/scraper-icon.df6ccde5.svg";